import fetch from '@/utils/fetch'
import {
    systemFetch
} from "@/utils/fetch";
/**
 * 统一处理请求参数
 * */
function filterURLSearchParams(args = {}) {
  const params = new URLSearchParams();
  Object.keys(args).forEach(key => {
    params.append(key, args[key])
  });
  return params
}

/**
 * 积分卡模板
 * */
/**
 * 查询积分卡片模板列表
 * */
export function getIntegralCardTemplateList(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralCardTemplateList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询积分卡片模板列表（分页）
 * */
export function getIntegralCardTemplatePageList(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralCardTemplatePageList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}
export function getIntegralCardTemplateSchList(args) {
    return fetch({
        url: 'structure/integralBank/getIntegralCardTemplateSchList',
        method: 'POST',
        data: filterURLSearchParams(args)
    })
}

/**
 * 根据ID删除积分卡模板
 * */
export function delIntegralCardTemplateById(args) {
  return fetch({
    url: 'structure/integralBank/delIntegralCardTemplateById',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 根据ID查询积分卡模板信息
 * */
export function getIntegralCardTemplateInfoById(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralCardTemplateInfoById',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}
export function querySchoolListByName(args) {
    return systemFetch({
        url: 'api/school/querySchoolListByName',
        method: 'POST',
        data: filterURLSearchParams(args)
    })
}

/**
 * 新增积分卡模板
 * */
export function addIntegralCardTemplate(args) {
  return fetch({
    url: 'structure/integralBank/addIntegralCardTemplate',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 编辑积分卡模板
 * */
export function editIntegralCardTemplate(args) {
  return fetch({
    url: 'structure/integralBank/editIntegralCardTemplate',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 积分卡
 * */
/**
 * 查询积分卡生成批次列表（分页）
 * */
export function getIntegralCardBatchPageList(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralCardBatchPageList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 根据ID积分卡详细信息
 * */
export function getIntegralCardInfoById(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralCardInfoById',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 生成积分卡
 * */
export function buildIntegralCard(args) {
  return fetch({
    url: 'structure/integralBank/buildIntegralCard',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 积分卡使用记录（分页）
 * */
export function getIntegralCardUsePageList(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralCardUsePageList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 积分卡记录列表（分页）
 * */
export function getIntegralCardPageList(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralCardPageList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 导出卡片为zip文件
 * */
export function exportBatchIntegralCardList(args) {
  return fetch({
    url: 'structure/integralBank/exportBatchIntegralCardList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 积分商城
 * */
/**
 * 查询商品列表（分页）
 * */
export function getIntegralGoodsPageList(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralGoodsPageList',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 新增商品
 * */
export function addIntegralGoods(args) {
  return fetch({
    url: 'structure/integralBank/addIntegralGoods',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 编辑商品
 * */
export function editIntegralGoods(args) {
  return fetch({
    url: 'structure/integralBank/editIntegralGoods',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 查询商品详细信息
 * */
export function getIntegralGoodsInfoById(args) {
  return fetch({
    url: 'structure/integralBank/getIntegralGoodsInfoById',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}

/**
 * 删除商品
 * */
export function deleteIntegralGoodsById(args) {
  return fetch({
    url: 'structure/integralBank/deleteIntegralGoodsById',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}
/**
 * 删除商品
 * */
export function updateIntegralGoodsStatus(args) {
  return fetch({
    url: 'structure/integralBank/updateIntegralGoodsStatus',
    method: 'POST',
    data: filterURLSearchParams(args)
  })
}



// WEBPACK FOOTER //
// ./src/api/integralBank.js